export const fontSizes = {
  normal: 14,
  medium: 16,
};
